<template>
  <footer>
    <div id="footerwrapper" class="page">
      <div id="adress">
        <address>
          <span class="link-margin">
            <a :href="fullTelHref" rel="nofollow" tabindex="0" aria-label="0771 - 6 7 0 6 7 0">{{ $t("footerTelefonnummer") }}</a>
          </span>
          <p>Bolagsverket<br/>
          {{ $t("footerPostnrOrt") }}</p>
        </address>
      </div>
      <div id="lankar">
        <span class="link-margin"><a :href="$t('kontakta_oss')" rel="noopener" :aria-label="$t('footerKontaktaOss') + ', våra kontaktvägar på Bolagsverket, öppnas i nytt fönster'">{{ $t("footerKontaktaOss") }}</a><img alt="" class="new-window" src="../../assets/ico_newwin-white.svg" /></span>
        <span class="link-margin"><a :href="$t('tillganglighet')" rel="noopener" :aria-label="$t('footerTillganglighet') + ', vår tillgänglighetsredogörelse på Bolagsverket, öppnas i nytt fönster'">{{ $t("footerTillganglighet") }}</a><img alt="" class="new-window" src="../../assets/ico_newwin-white.svg" /></span>
        <span class="link-margin"><a :href="$t('personuppgifter')" rel="noopener" :aria-label="$t('footerPersonuppgifter') + ', hur vi hanterar personuppgifter på Bolagsverket, öppnas i nytt fönster'">{{ $t("footerPersonuppgifter") }}</a><img alt="" class="new-window" src="../../assets/ico_newwin-white.svg" /></span>
      </div>
      <div id="logga">
        <img
          class="logo"
          src="../../../public/images/logo-bw.svg"
          alt=""
        />
      </div>
    </div>
  </footer>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";
const i18n = useI18n();
const locale = i18n.locale.value;
const fullTelHref =
  "tel:" + i18n.messages.value[locale].footerTelefonnummerHref;
const fullKontaktaOss = i18n.messages.value[locale]["kontakta_oss"].toString();
</script>

<style lang="scss" scoped>

footer {
  width: 100%;
  background-color: #002857;
  color: #fff;
  padding-bottom: 2em;
  bottom: 0; 
  min-height: 9em;
}
.link-margin {
  margin-bottom: 0.5rem;
}
.link-margin:last-child {
  margin-bottom: 0;
}

.new-window {
  height:1rem;position: relative; top:2px;padding-left:10px;
}
#logga {
  align-self: self-end;
  display: inline-flex;
}
.logo {
  margin-bottom: 0.5rem;
}
footer a {
    text-decoration: underline;
}
footer a:hover,
footer a:focus {
    text-decoration: underline;
    text-underline-position: under;
}
#footerwrapper {
  position: relative;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-top: 3rem;
  padding-bottom: 3rem;
}
#footerwrapper span {
  display: block;
  white-space: nowrap;
}
#footerwrapper a {
  color: inherit;
}
#footerwrapper address p {
  color: #fff;
}
#footerwrapper address a {
  font-weight: bold;
}
@media screen and (max-width: 70em) {
  #footerwrapper {
    position: relative;
    margin: 0;
    margin-left: auto;
    margin-right: auto;
    padding-left:2rem;
    padding-right:2rem;
  }
  #lankar {
    margin-top:0;
  }
  #logga {
    margin-top:2rem;
  }
}
@media screen and (max-width: 35em) {
  #footerwrapper {
    display: block;
    position: relative;
    margin: 0 1em;
    margin-left: auto;
    margin-right: auto;
    padding-left:2rem;
    padding-right:2rem;
  }
  #lankar {
    margin-top:1.5rem;
  }
  #logga {
    margin-top:2rem;
  }
}
</style>
